import { html, TemplateResult } from 'lit';
import { PropertyDataUpdateLatch } from '../../api/get-calendar-data-for-house';
import { staticText } from '../../static-text';
import { BookingRequest, Dispatcher } from '../../types/booking-request';
import { showStepWhenCurrentIs, stepId, STEP_SELECT_A_HOUSE } from '../../types/steps';
import { WPContent, WPHousePosts } from '../../types/wp-data';
import { houseList } from './partials/house-list';
import { stepIntro } from './partials/step-intro';

export function stepSelectAHouse(
	state: BookingRequest,
	dispatch: Dispatcher,
	propertyDataUpdateLatch: PropertyDataUpdateLatch,
	content: WPContent,
	posts: WPHousePosts
): TemplateResult {
	if ( !( showStepWhenCurrentIs( STEP_SELECT_A_HOUSE, state.currentStep ) ) ) {
		return html``;
	}

	return html`
		<div class="step" id="${stepId( STEP_SELECT_A_HOUSE )}">
			<div class="section theme-grey-light">
				<div class="wrapper">
					<div class="double-columns">
						<div class="double-columns__column">
							${stepIntro( content.titleSelectAHouse, content.textSelectAHouse )}
						</div>
					</div>

					<nav
						aria-label="${staticText.availableHousesForRent}"
						class="houses-overview"
					>
						<ul
							class="houses-overview__list"
							role="list"
						>
							${houseList( state, dispatch, propertyDataUpdateLatch, posts )}
						</ul>
					</nav>
				</div>
			</div>
		</div>
	`;
}
